import { div } from '@mui/system'
import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilled, ButtonFilledAutoWidth } from '../../../components/button'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { CreateDepartmentService, UpdateDepartmentService } from '../../../services/DepartmentServices'
import { useNavigate, useLocation } from 'react-router-dom'
import { MobileBackOption } from '../../../components/appbars/mobile/DashboardMobile'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { message, Select } from 'antd'
import { CreateFollowupService, UpdateFollowupService } from '../../../services/admin/FollowupServices'
import { CreateStudentSubjectService, UpdateStudentSubjectService } from '../../../services/admin/StudentSubjectServices'
import { GetClassStreamService } from '../../../services/admin/StudentStreamServices'
import { GetFilterStandardDashboardService } from '../../../services/DashboardServices'
import { GetFileStandardService } from '../../../services/admin/FileStandardServices'
import { GetStudentBoardService } from '../../../services/admin/StudentBoardServices'

function StudentSubjectCE() {
 
  const [data,setdata] = useState({name:'',label:'',match_string:'',streams:[],sub_streams:[],boards:[],standards:[]});  
  const [error,seterror] = useState({name:'',label:'',match_string:'',streams:'',sub_streams:'',boards:'',standards:''}); 
  
  const [standards,setstandards] = useState([]);
  const [streams,setstreams] = useState([]);
  const [boards,setboards] = useState([]);



  const {state} = useLocation();
  const navigate = useNavigate();

  useEffect(()=>{
    getAllData()
  },[])

  async function getAllData(){
    const response = await GetClassStreamService()
    const response1 = await GetFileStandardService()
    const response2 = await GetStudentBoardService()

    let arr = [...response.data.datas?.map((d)=>({value:d._id,label:d.name,data:d}))]
    let arr1 = [...response1.data.datas?.map((d)=>({value:d._id,label:d.label}))]
    let arr2 = [...response2.data.datas?.map((d)=>({value:d._id,label:d.name}))]
    
    setstreams(arr)
    setstandards(arr1)
    setboards(arr2)


  }

  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){

      let setData = {
        ...state,
        streams: state.streams?.map((s)=>({label:s?.name,value:s?._id,data:s})),
        sub_streams: state.sub_streams?.map((s)=>({label:s?.name,value:s?._id,data:s})),
        boards: state.boards?.map((s)=>({label:s?.name,value:s?._id,data:s})),
        standards: state.standards?.map((s)=>({label:s?.name,value:s?._id,data:s})),
      }
      setdata({...data,...setData})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    if(!data.name){
        seterror({...error,name:'Name field is required *'})
    }else if(!data.label){
        seterror({...error,label:'Label field is required *'})
    }else if(!data.match_string){
        seterror({...error,match_string:'Match String field is required *'})
    }else{

      let send_data = {...data}
      send_data.streams = data.streams?.map((d)=>d.value)
      send_data.sub_streams = data.sub_streams?.map((d)=>d.value)
      send_data.boards = data.boards?.map((d)=>d.value)
      send_data.standards = data.standards?.map((d)=>d.value)

      if(send_data.streams?.length === 0){
        delete send_data.streams
      }
      if(send_data.sub_streams?.length === 0){
        delete send_data.sub_streams
      } 
      if(send_data.boards?.length === 0){
        delete send_data.boards
      }
      if(send_data.standards?.length === 0){
        delete send_data.standards
      }
        if(state?._id === undefined || state?._id === null){
        const response = await CreateStudentSubjectService(send_data)
        if (response.status === 201) {
          resetform()
          toast.success('Student Subject Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,days:response?.data?.errors?.days})
        } 
      }else{
        let send_data = {...data}
        send_data.streams = data.streams?.map((d)=>d.value)
        send_data.sub_streams = data.sub_streams?.map((d)=>d.value)
        send_data.boards = data.boards?.map((d)=>d.value)
        send_data.standards = data.standards?.map((d)=>d.value)

        if(send_data.streams?.length === 0){
          delete send_data.streams
        }
        if(send_data.sub_streams?.length === 0){
          delete send_data.sub_streams
        } 
        if(send_data.boards?.length === 0){
          delete send_data.boards
        }
        if(send_data.standards?.length === 0){
          delete send_data.standards
        }
        const response = await UpdateStudentSubjectService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Student Subject Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,days:response?.data?.errors?.days})
        } 
      }
  }
  }


  function resetform(){
    setdata({name:'',label:'',match_string:'',streams:[],sub_streams:[],boards:[],standards:[]})
    seterror({name:'',label:'',match_string:'',streams:'',sub_streams:'',boards:'',standards:''})
  }
  
  async function handleSelect(e,e1){
    if(e1 === 'streams'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(streams?.find((r)=>r?.value === ele))
      })
      setdata({...data,streams:arr})
      seterror({...error,streams:''})
    }else if(e1 === 'standards'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(standards?.find((r)=>r?.value === ele))
      })
      setdata({...data,standards:arr})
      seterror({...error,standards:''})
    }else if(e1 === 'boards'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(boards?.find((r)=>r?.value === ele))
      })
      setdata({...data,boards:arr})
      seterror({...error,boards:''})
    }else if(e1 === 'sub_streams'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(streams?.find((r)=>r?.value === ele))
      })
      setdata({...data,sub_streams:arr})
      seterror({...error,sub_streams:''})
    }
  }

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} Student Subject</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Student Subject</b> for your clients segregate followup.</h6>
     

        <TextInput 
            label={'Name'}  
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder="Enter your name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

          <TextInput 
            label={'Label'}  
            variant="standard"
            name="label"
            type="text"
            error={error.label}
            value={data.label}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>  

             <TextAreaInput1 
            label={'Match String'}  
            variant="standard"
            name="match_string"
            type="text"
            error={error.match_string}
            value={data.match_string}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Stream</h6>
                <Select
                  value={data.streams} 
                  filterOption={false}
                  bordered={false}
                  mode='multiple'
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'streams')} 
                  options={streams?.filter((s)=>s?.data?.parent_stream?.name === undefined)} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Sub Stream </h6>
                <Select
                  value={data.sub_streams} 
                  filterOption={false}
                  bordered={false}
                  mode='multiple'
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'sub_streams')} 
                  options={streams?.filter((s)=>s?.data.parent_stream !== undefined)} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Standard </h6>
                <Select
                  value={data.standards} 
                  filterOption={false}
                  bordered={false}
                  mode='multiple'
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'standards')} 
                  options={standards} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Board </h6>
                <Select
                  value={data.boards} 
                  filterOption={false}
                  bordered={false}
                  mode='multiple'
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'boards')} 
                  options={boards} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE STUDENT SUBJECT" : "ADD STUDENT SUBJECT"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default StudentSubjectCE